import { useMutation } from 'react-query';
import { updateDefaultLogo } from '../apis/UpdateDefaultLogo';

export const useUpdateDefaultLogoMutation = () =>
  useMutation(updateDefaultLogo);
